module.exports = __webpack_public_path__ + "assets/img/4ceb9c8cd7cdd977513d60d90a62ff2a.png";